export default {
	empresas: state => {
		return state.empresas;
	},
	todasAsContasGerenciais: state => {
		return state.todasAsContasGerenciais;
	},
	loadingCompanies: state => {
		return state.loadingCompanies;
	},
	usuarioAutenticado: state => {
		return state.loggedUser;
	},
	totalDeDespesa: state => {
		return state.totalDespesas;
	}
}